import difference from "lodash-es/difference";

import { PermissionSiteDetailsPageFormData } from "./components/PermissionSiteDetailsPage";
import { PermissionSiteDetails_permissionSite } from "./types/PermissionSiteDetails";

/**
 * Return lists of users which have to be added and removed from Site.
 */
export const usersDiff = (
  permissionSite: PermissionSiteDetails_permissionSite,
  formData: PermissionSiteDetailsPageFormData
) => {
  const newUsers = formData.users.map(u => u.id);
  const oldUsers = permissionSite?.users.map(u => u.id);

  return {
    addUserids: difference(newUsers, oldUsers),
    removeUserids: difference(oldUsers, newUsers)
  };
};
